<template>
  <select @change="$emit('change', selectedAddress)" v-model="selectedAddress">
    <checkout-address-option :address="address" v-for="address in addresses" :key="address['entity_id']"></checkout-address-option>
    <option :value="newAddress">{{ $t('Add new address') }}</option>
  </select>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'checkout-address-select',
    components: {
      'checkout-address-option': ServiceContainer().getComponent('checkout-address-option')
    }
  })

  export default class extends Vue {
    @Prop() private addresses: Array<object>;
    @Prop() private defaultAddress: object;

    private selectedAddress: object = {
      prefix: '',
      firstname: '',
      middlename: '',
      lastname: '',
      postcode: '',
      street: ['', '', ''],
      city: '',
      telephone: '',
      company: '',
      country_id: 'NL'
    };

    private newAddress: object = {
      newAddress: true,
      prefix: '',
      firstname: '',
      middlename: '',
      lastname: '',
      postcode: '',
      street: ['', '', ''],
      city: '',
      telephone: '',
      company: '',
      country_id: 'NL'
    };

    private created(): void {
      if (this.addresses.length) {
        if (this.defaultAddress?.['entity_id']) {
          this.selectedAddress = this.defaultAddress;
        } else {
          this.selectedAddress = this.addresses[0];
        }
      } else {
        Object.freeze(this.newAddress);
        this.selectedAddress = this.newAddress;
      }

      this.$emit('change', this.selectedAddress);
    }
  }
</script>
